// extracted by mini-css-extract-plugin
export default {"main":"Vision_main__3654I","box":"Vision_box__Eu56L"};